module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/userPrivacy-fileBackup.c98498d3.png";